import Vue from 'vue';
import store from './store';
import router from './router';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import App from './App_v2.vue';
import i18n from '@/plugins/i18n';
import { required, email } from 'vee-validate/dist/rules';
import axios from '@/utils/axios';
import Clipboard from 'v-clipboard';
import { ValidationProvider, extend } from 'vee-validate';
import VueApexCharts from 'vue-apexcharts';
import VueGtag from 'vue-gtag';
import { ADMIN, STUDENT, TEACHER, ASSOCIATE_ADMIN } from '@/constants/userRoles';
import { EDUCATION } from '@/constants/organizationType';
import '@/plugins/awesomefont';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$i18nLabelsHelper = function (orgType, label) {
	return EDUCATION.indexOf(orgType) > -1 ? `school_labels.${label}` : `company_labels.${label}`;
};
Vue.prototype.$labelRole = (orgType, roleValue) => {
	switch (roleValue) {
		case STUDENT:
			return 'Learner';
		case TEACHER:
			return EDUCATION.indexOf(orgType) > -1 ? 'Teacher' : 'Team Leader';
		case ADMIN:
			return 'Default Admin';
		case ASSOCIATE_ADMIN:
			return 'Associate Admin'
		default:
			return 'User';
	}
};

Vue.use(VueApexCharts);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('apexchart', VueApexCharts);
Vue.use(ElementUI, { locale });
Vue.use(Clipboard);

// Custom rules
extend('email', email);

extend('required', required);

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);

// Google Analytics
Vue.use(VueGtag, {
	config: {
		id: process.env.VUE_APP_GOOGLE_ANALYTICS
	}
});

// reCAPTCHA-v3
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_STRIPE_CAPTCHA_KEY,
  loaderOptions: {
    autoHideBadge: true,
  },
})

new Vue({
	store,
	router,
	i18n,
	render: (h) => h(App)
}).$mount('#app');
